var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"IPHeader"},[_c('div',{staticStyle:{"width":"60px","height":"60px"}}),_c('div',{staticClass:"fileName"},[_vm._v(_vm._s(_vm.fileName))]),_c('div',{staticClass:"IPClose",attrs:{"id":"IPCloseId"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('BwStop')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }